module.exports = __webpack_public_path__ + "media/se_show_highscore.0757e778.mp3";